export enum ActionNameEnum {
  NEW_QUOTE = 'NEW_QUOTE',
  ACCEPT_QUOTE = 'ACCEPT_QUOTE',
  REJECT_QUOTE = 'REJECT_QUOTE',
  BOOK_QUOTE = 'BOOK_QUOTE',
  COUNTEROFFERED_QUOTE = 'COUNTEROFFERED_QUOTE',
  AIRLINE_PENDING = 'AIRLINE_PENDING',
  ALTERNATIVE_FLIGHT = 'ALTERNATIVE_FLIGHT',
  FORWARDER_RATING = 'FORWARDER_RATING',
  CANCEL_BOOKING = 'CANCEL_BOOKING',
  REQUESTED_CANCEL_BOOKING = 'REQUESTED_CANCEL_BOOKING',
  IN_TRANSIT = 'IN_TRANSIT',
  SHIPMENT_DELIVERED = 'SHIPMENT_DELIVERED',
  CHANGED_AWB = 'CHANGED_AWB',
  CHANGED_ALLOTMENT_ID = 'CHANGED_ALLOTMENT_ID',
  CHANGED_QUOTE_VALIDITY = 'CHANGED_QUOTE_VALIDITY',
  CARGO_UPDATE = 'CARGO_UPDATE',
  SHC_UPDATE = 'SHC_UPDATE',
  CHANGED_QUOTE_REMARK = 'CHANGED_QUOTE_REMARK',
  RESEND_EMAIL = 'RESEND_EMAIL',
  FWB_NOTIFY_UPDATE = 'FWB_NOTIFY_UPDATE',
  FWB_SHIPPER_UPDATE = 'FWB_SHIPPER_UPDATE',
  FWB_CONSIGNEE_UPDATE = 'FWB_CONSIGNEE_UPDATE',
  FWB_EXECUTION_UPDATE = 'FWB_EXECUTION_UPDATE',
  FWB_CHARGES_UPDATE = 'FWB_CHARGES_UPDATE',
  FWB_RATES_UPDATE = 'FWB_RATES_UPDATE',
  FHL_UPDATE = 'FHL_UPDATE',
  SYSTEM_SETTLED = 'SYSTEM_SETTLED',
  AT_DESTINATION = 'AT_DESTINATION',
}
